
import { EditorValidator } from "slickgrid-react";
import Contractor from ".";
import BaseGrid, { BasicGridProps } from "../../components/grid/BaseGridComponent";
import { State } from "../../components/grid/BasicGridState";
import ContractorService from "../../services/contractor/contractor.service";
import * as React from 'react';

interface ValidatorState{
  nip_exist: boolean;
}

interface ValidatorProps{
  //shortname_exist: boolean;
}


class ContractorValidators{
    sender: BaseGrid;
    state : ValidatorState;
    constructor(sender: any) {
     // super(sender);
        this.sender = sender  
        this.state = {nip_exist: false};
     }

     nameValidator :EditorValidator = (value: any) => {
      
        let ready=false
        if (value === null || value === undefined || !value.length) {
          this.sender.setState((state: State, props: BasicGridProps) => ({
            ...state,
            alertErrorMsg: []
          }));
          return { valid: false, msg: 'To pole jest wymagane' };
        }else if (value.length>255) {
          this.sender.setState((state: State, props: BasicGridProps) => ({
            ...state,
            alertErrorMsg: []
          }));
          return {
            valid: false,
            msg: 'To pole przyjmuje maksymalnie 255 znaków',
          };
    
        }else{
          var selectRow =this.sender.reactGrid.slickGrid.getSelectedRows();
          var id=-1
          var name=value
          var shortname=''
          var nip=''
          if (selectRow.length ==1){
            if (this.sender.reactGrid.slickGrid.getDataItem(selectRow[0])){
              id = this.sender.reactGrid.slickGrid.getDataItem(selectRow[0]).id
            }
          }
          if (value.length>3){
           ContractorService.contractorExist(name, shortname, nip, id).then(response => {
            if ( Array.isArray(response) && response.length >0){
              var msg: string[]=[]
              for (const element of response) {
                var tmp = "Istnieje kontrahent: Nazwa skrócona: " + element.name + ", NIP: " + element.nip+  ", Nazwa: " + element.shortname +  ", Grupa: " + element.group_names
                msg.push(tmp)
              }
                  this.sender.setState((state: State, props: BasicGridProps) => ({
                    ...state,
                    alertErrorMsg:msg
                  }));
            
          
            }else{
              this.sender.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertErrorMsg: []
              }));
            }
          }
          ).catch(
            (error) => {
              this.sender.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: error
          }));
            }
          )
        }else{
          this.sender.setState((state: State, props: BasicGridProps) => ({
            ...state,
            alertErrorMsg: []
          }));
          this.state.nip_exist =  false;
        }
        }
       
        return { valid: true, msg: '' };
      };
      
      shortnameValidator :EditorValidator = (value: any) => {
        let ready=false
        if (value === null || value === undefined || !value.length) {
          this.sender.setState((state: State, props: BasicGridProps) => ({
            ...state,
            alertErrorMsg: []
          }));
          return { valid: false, msg: 'To pole jest wymagane' };
        }else if (value.length>120) {
          this.sender.setState((state: State, props: BasicGridProps) => ({
            ...state,
            alertErrorMsg: []
          }));
          return {
            valid: false,
            msg: 'To pole przyjmuje maksymalnie 120 znaków',
          };
    
        }else{
          var selectRow =this.sender.reactGrid.slickGrid.getSelectedRows();
          var id=-1
          var name=''
          var shortname=value
          var nip=''
          if (selectRow.length ==1){
            if (this.sender.reactGrid.slickGrid.getDataItem(selectRow[0])){
              id = this.sender.reactGrid.slickGrid.getDataItem(selectRow[0]).id
            }
          }

          if (value.length>3){
           ContractorService.contractorExist(name, shortname, nip, id).then(response => {
           
                if ( Array.isArray(response) && response.length >0){
                  var msg: string[]=[]
                  for (const element of response) {
                    var tmp = "Istnieje kontrahent: Nazwa skrócona: " + element.name + ", NIP: " + element.nip+  ", Nazwa: " + element.shortname +  ", Grupa: " + element.group_names
                    msg.push(tmp)
                  }
                      this.sender.setState((state: State, props: BasicGridProps) => ({
                        ...state,
                        alertErrorMsg:msg
                      }));
                      
                }else{
                  this.sender.setState((state: State, props: BasicGridProps) => ({
                    ...state,
                    alertErrorMsg: []
                  }));
                  this.state.nip_exist =  false;
                }
          }
          ).catch(
            (error) => {
              this.sender.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: error
          }));
            }
          )
         }else{
          this.sender.setState((state: State, props: BasicGridProps) => ({
            ...state,
            alertErrorMsg: []
          }));
          this.state.nip_exist =  false;
         }
        }

        return { valid: true, msg: '' };
      };


    phoneValidator: EditorValidator = (value: any) => {

        if (value.length>100) {
        return {
            valid: false,
            msg: 'To pole przyjmuje maksymalnie 100 znaków',
        };
        }else if (/[a-zA-Z]+/.test(value)){
        return { valid: false, msg: 'Numer telefonu nie może zawierać liter [a-z A-Z]' };
        }
        return { valid: true, msg: '' };
    };

    
    postcodeValidator: EditorValidator = (value: any) => {
        if (value.length>20) {
        return {
            valid: false,
            msg: 'To pole przyjmuje maksymalnie 20 znaków',
        };
        }else if (/[a-zA-Z]+/.test(value)){
        return { valid: false, msg: 'Kod pocztowy nie może zawierać liter [a-z A-Z]' };
        }
        return { valid: true, msg: '' };
   };

   maxlength100Validator: EditorValidator = (value: any) => {
      if (value.length>100) {
        return {
            valid: false,
            msg: 'To pole przyjmuje maksymalnie 100 znaków',
        };
      }
      return { valid: true, msg: '' };
   };

    nipValidator: EditorValidator = (value: any) => {
  
      if (value.length>100) {
      return {
          valid: false,
          msg: 'To pole przyjmuje maksymalnie 100 znaków',
      };
      }else if (/[a-zA-Z]+/.test(value)){
        return { valid: false, msg: 'Numer NIP nie może zawierać liter [a-z A-Z]' };
      }else{
        var selectRow =this.sender.reactGrid.slickGrid.getSelectedRows();
        var id=-1
        var name=''
        var shortname=''
        var nip=value
        if (selectRow.length ==1){
          if (this.sender.reactGrid.slickGrid.getDataItem(selectRow[0])){
            id = this.sender.reactGrid.slickGrid.getDataItem(selectRow[0]).id
          }
        }

       
           ContractorService.contractorExist(name, shortname, nip, id).then(response => {
         
              if ( Array.isArray(response) && response.length >0){
                var msg: string[]=[]
                for (const element of response) {
                  var tmp = "Istnieje kontrahent: Nazwa skrócona: " + element.name + ", NIP: " + element.nip+  ", Nazwa: " + element.shortname +  ", Grupa: " + element.group_names
                  msg.push(tmp)
                }

               
                    this.sender.setState((state: State, props: BasicGridProps) => ({
                      ...state,
                      alertErrorMsg:msg
                    }));

                    this.state.nip_exist =  true;
              
            
              }else{
                this.sender.setState((state: State, props: BasicGridProps) => ({
                  ...state,
                  alertErrorMsg: []
                }));
                this.state.nip_exist =  false;
              }
        }
        ).catch(
          (error) => {
            this.sender.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: error
        }));
          }
        )
      } 

      if (this.state.nip_exist){
          
        return {
          valid: false,
          msg: 'Istnieje kontrahent o podanym NIP-ie',
        };
      }
      return { valid: true, msg: '' };
  };

  regonValidator: EditorValidator = (value: any) => {

      if (value.length>100) {
      return {
          valid: false,
          msg: 'To pole przyjmuje maksymalnie 100 znaków',
      };
      }else if (/[a-zA-Z]+/.test(value)){
      return { valid: false, msg: 'Numer REGON nie może zawierać liter [a-z A-Z]' };
      }
      return { valid: true, msg: '' };
  };

  krsValidator: EditorValidator = (value: any) => {

      if (value.length>100) {
      return {
          valid: false,
          msg: 'To pole przyjmuje maksymalnie 100 znaków',
      };
      }else if (/[a-zA-Z]+/.test(value)){
      return { valid: false, msg: 'Numer KRS nie może zawierać liter [a-z A-Z]' };
      }
      return { valid: true, msg: '' };
  };

    emailValidator: EditorValidator = (value: any) => {
        if (!(value === null || value === undefined || !value.length)) {
          if (value.length>100) {
              return {
              valid: false,
              msg: 'To pole przyjmuje maksymalnie 100 znaków',
              };
          }else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/.test(value)){
              return { valid: false, msg: 'Nieprawidłowy format adresu e-mail' };
          }
        }
        return { valid: true, msg: '' };
    };
}

export default ContractorValidators